// Author thq
// Date 2023-11-03 10:34:14

class TpmOeeSpindleDataFetch {
    constructor({
                    id = null,
                    tsdSpindleSpeed = '',
                    tsdSpindleOverride = '',
                    tsdSpindleLoad = '',
                    tsdSpindleAload = '',
                    tsdSpindleC1load = '',
                    tsdSpindleState = '',
                    tsdFeedSpeed = '',
                    tsdFeedOverride = '',
                    tsdGeometricX = '',
                    tsdGeometricY = '',
                    tsdGeometricZ = '',
                    tsdOperatorId = '',
                    tsdOperatorName = '',
                    tsdDeptName = '',
                    tsdProjectCode = '',
                    tsdItemName = '',
                    tsdOrderCode = '',
                    tsdOperateSeq = '',
                    prdPpOperationName = '',
                    tsdLocationId = '',
                    tsdMstLocName = '',
                    tsdCollectTime = '',
                    tsdDeviceCode = '',
                    tsdDeviceSystemType = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.tsdSpindleSpeed = tsdSpindleSpeed;
        this.tsdSpindleOverride = tsdSpindleOverride;
        this.tsdSpindleLoad = tsdSpindleLoad;
        this.tsdSpindleAload = tsdSpindleAload;
        this.tsdSpindleC1load = tsdSpindleC1load;
        this.tsdSpindleState = tsdSpindleState;
        this.tsdFeedSpeed = tsdFeedSpeed;
        this.tsdFeedOverride = tsdFeedOverride;
        this.tsdGeometricX = tsdGeometricX;
        this.tsdGeometricY = tsdGeometricY;
        this.tsdGeometricZ = tsdGeometricZ;
        this.tsdOperatorId = tsdOperatorId;
        this.tsdOperatorName = tsdOperatorName;
        this.tsdDeptName = tsdDeptName;
        this.tsdProjectCode = tsdProjectCode;
        this.tsdItemName = tsdItemName;
        this.tsdOrderCode = tsdOrderCode;
        this.tsdOperateSeq = tsdOperateSeq;
        this.prdPpOperationName = prdPpOperationName;
        this.tsdLocationId = tsdLocationId;
        this.tsdMstLocName = tsdMstLocName;
        this.tsdCollectTime = tsdCollectTime;
        this.tsdDeviceCode = tsdDeviceCode;
        this.tsdDeviceSystemType = tsdDeviceSystemType;
        this.remark = remark;
    }
}

function newEntity() {
    return new TpmOeeSpindleDataFetch();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdDeviceCode',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdDeviceCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdDeviceSystemType',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdDeviceSystemType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdCollectTime',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdCollectTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdOperatorId',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdOperatorId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdOperatorName',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdOperatorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdDeptName',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdDeptName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdProjectCode',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdProjectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdItemName',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdItemName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdOrderCode',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdOperateSeq',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdOperateSeq',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prdPpOperationName',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.prdPpOperationName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdLocationId',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdLocationId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdMstLocName',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdMstLocName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },


        {
            key: 'tsdSpindleSpeed',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdSpindleSpeed',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleOverride',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdSpindleOverride',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleLoad',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdSpindleLoad',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleAload',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdSpindleAload',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleC1load',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdSpindleC1load',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdSpindleState',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdSpindleState',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdFeedSpeed',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdFeedSpeed',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdFeedOverride',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdFeedOverride',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdGeometricX',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdGeometricX',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdGeometricY',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdGeometricY',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tsdGeometricZ',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.tsdGeometricZ',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },


        {
            key: 'remark',
            label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    tsdSpindleSpeedFilter: '',
    tsdSpindleOverrideFilter: '',
    tsdSpindleLoadFilter: '',
    tsdSpindleStateFilter: '',
    tsdFeedSpeedFilter: '',
    tsdFeedOverrideFilter: '',
    tsdGeometricXFilter: '',
    tsdGeometricYFilter: '',
    tsdGeometricZFilter: '',
    tsdOperatorIdFilter: '',
    tsdOperatorNameFilter: '',
    tsdDeptNameFilter: '',
    tsdProjectCodeFilter: '',
    tsdItemNameFilter: '',
    tsdOrderCodeFilter: '',
    tsdOperateSeqFilter: '',
    prdPpOperationNameFilter: '',
    tsdLocationIdFilter: '',
    tsdMstLocNameFilter: '',
    tsdCollectTimeRteFilter: '',
    tsdCollectTimeLteFilter: '',
    tsdDeviceCodeFilter: '',
    tsdDeviceSystemTypeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'tsdOperatorNameFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.tsdOperatorName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeptNameFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.tsdDeptName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdProjectCodeFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.tsdProjectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdItemNameFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.tsdItemName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdOrderCodeFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.tsdOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpOperationNameFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.prdPpOperationName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdMstLocNameFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.tsdMstLocName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdCollectTimeRteFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.tsdCollectTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdCollectTimeLteFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.tsdCollectTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeviceCodeFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.tsdDeviceCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeviceSystemTypeFilter',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.filter.tsdDeviceSystemType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'tsdSpindleSpeed',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdSpindleSpeed',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdSpindleOverride',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdSpindleOverride',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdSpindleLoad',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdSpindleLoad',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdSpindleAload',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdSpindleAload',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdSpindleC1load',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdSpindleC1load',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdSpindleState',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdSpindleState',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdFeedSpeed',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdFeedSpeed',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdFeedOverride',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdFeedOverride',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdGeometricX',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdGeometricX',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdGeometricY',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdGeometricY',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdGeometricZ',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdGeometricZ',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdOperatorId',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdOperatorId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdOperatorName',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdOperatorName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeptName',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdDeptName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdProjectCode',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdProjectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdItemName',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdItemName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdOrderCode',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdOrderCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdOperateSeq',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdOperateSeq',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prdPpOperationName',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.prdPpOperationName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdLocationId',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdLocationId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdMstLocName',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdMstLocName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdCollectTime',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdCollectTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeviceCode',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdDeviceCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tsdDeviceSystemType',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.tsdDeviceSystemType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.statusCollection.tpmOeeSpindleDataFetch.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    TpmOeeSpindleDataFetch, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
